<template>
  <!-- 2u 외에서 사용하는 예약 상세 정보 페이지-->
  <v-container>
    <div class="page-title">{{$route.name}}</div>

    <v-row>
      <v-col class="d-flex justify-end">

        <c-btn class="mx-1" color="blue" outlined iconName="cancel" :disabled="isRsCancel || isWithdrawalCustomer" @click="cancelDialogOpen = true">
          예약취소
        </c-btn>
        <c-btn class="mx-1" color="blue" outlined iconName="create" :disabled="isRsUpdate || isWithdrawalCustomer" @click="onUpdateReservationPassenger">
          탑승자변경
        </c-btn>
        <c-btn class="mx-1" color="blue" outlined iconName="create" :disabled="isRsUpdate || isWithdrawalCustomer" @click="onUpdateReservationInfo">
          예약정보변경
        </c-btn>
        <c-btn class="mx-1" color="blue" outlined iconName="alarm" :disabled="isRsUpdate || isWithdrawalCustomer" @click="onUpdateReservation">
          예약변경
        </c-btn>
        <c-btn class="mx-1" color="grey" outlined iconName="mdi-format-list-bulleted-square" @click="$router.go(-1)">
          돌아가기
        </c-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-0">
        <c-card>
          <reservation-detail-dialog
            :reservationData="reservationWithPassenger"
            :canceledResrvId="canceledResrvId"
            reservationStateEventFlag
            reservationEditableFlag
            @changeReservationState="onChangeReservationState"
            @reloadReservation="reqReservation"
          />
          <v-divider></v-divider>
          <v-row class="px-3">
            <v-col cols="12" md="2" sm="6">
              <span class="font-weight-black">배차 방법 여부</span>
            </v-col>
            <v-col cols="12" md="10" sm="6">
              <span>{{getAssignType}}</span>
            </v-col>
          </v-row>
        </c-card>
      </v-col>
    </v-row>

    <!-- 예약 취소 다이얼로그 -->
    <v-dialog
      v-model="cancelDialogOpen"
      hide-overlay
      persistent
      width="380"
    >
      <c-card class="white">
        <v-row justify="center" class="ma-5 title font-weight-bold">예약을 취소하시겠습니까?</v-row>
        <v-row justify="center" class="ma-3">
          <c-btn color="blue" large block @click="onCanceledReservation(1)">예 (승객으로 인한 취소)</c-btn>
        </v-row>
        <v-row justify="center" class="ma-3">
          <c-btn color="blue" large block @click="onCanceledReservation(2)">예 (관리자에 의한 취소)</c-btn>
        </v-row>
        <v-row justify="center" class="ma-3">
          <c-btn color="grey" large block @click="cancelDialogOpen = false">아니오</c-btn>
        </v-row>
      </c-card>
    </v-dialog>

    <!-- 예약 정보변경 다이얼로그 -->
    <reservation-update-dialog
      :open.sync="updateResrvInfoDialog"
      :reservationData="reservationInfo"
      @editReservationInfo="reqTinyUpdateReservation"
    />

    <v-dialog v-model="updateCustomerDialog" fullscreen transition="dialog-bottom-transition" hide-overlay>
      <c-card class="white">
        <v-toolbar dark color="primary">
          <c-btn iconName="mdi-close" @click="updateCustomerDialog = false" elevation="0" color="primary"></c-btn>
          <v-toolbar-title>탑승자 변경</v-toolbar-title>
        </v-toolbar>
        <v-row>
          <customer-info2 :customer-data.sync="updateCustomerInfoList"
            :passenger-data-list.sync="passengerDataList"
          ></customer-info2>
        </v-row>
        <v-row justify="center">
        <c-btn class="mr-1 mt-2" color="blue" outlined @click="updateCustomerList">수정</c-btn>
        <c-btn class="mt-2" color="gray" outlined @click="updateCustomerDialog = false">취소</c-btn>
        </v-row>
      </c-card>

    </v-dialog>


  </v-container>
</template>
<script>
  import ReservationUpdateDialog from './ReservationUpdateDialog';
  import ReservationDetailDialog from "@/views/CallTaxi/Reserve/ReservationDetailDialog";
  import CustomerInfo2 from "@/views/CallTaxi/Reserve/CustomerInfo2";

  export default {
    components: {ReservationUpdateDialog, ReservationDetailDialog, CustomerInfo2},
    data: () => ({
      updateResrvInfoDialog : false,
      reservationInfo: [],
      passengerList: [],
      reservationWithPassenger:[],
      reservationId: null,

      cancelDialogOpen: false,
      canceledResrvId:null,
      updateCustomerDialog: false,
      updateCustomerInfoList:[],
      passengerDataList: [],
    }),
    mounted() {
      const {reservationId} = this.$route.params;
      this.reservationId = reservationId;
      this.reqReservation();
    },
    computed: {
      getAssignType() {
        let type = '-';
        const reservationInfo = this.reservationInfo[0];
        if (reservationInfo && reservationInfo.assignType) {
          type = this.reservationInfo[0].assignType === 'M' ? '수동배차' : '자동배차';
        }
        return type;
      },
      isRsReceipt() {
        if (this.reservationInfo && this.reservationInfo.length > 0) {
          const reservationInfo = this.reservationInfo[0];
          return reservationInfo && reservationInfo.resrvState.configValue !== 'rs_receipt'
        }
        return false;
      },
      isRsCancel() {
        if (this.reservationInfo && this.reservationInfo.length > 0) {
          const reservationInfo = this.reservationInfo[0];
          return reservationInfo && reservationInfo.resrvState.configValue === 'rs_cancel' || reservationInfo.resrvState.configValue === 'rs_driving' || reservationInfo.resrvState.configValue === 'rs_done'
        }
        return false;
      },
      isRsUpdate() {
        if (this.reservationInfo && this.reservationInfo.length > 0) {
          const reservationInfo = this.reservationInfo[0];
          return reservationInfo && reservationInfo.resrvState.configValue === 'rs_cancel' || reservationInfo.resrvState.configValue === 'rs_driving' || reservationInfo.resrvState.configValue === 'rs_done'
        }
        return false;
      },
      isWithdrawalCustomer() {
        return this.passengerList?.length > 0 && this.passengerList[0].customer.state === 'Disable';
      }
    },
    methods: {
      async updateCustomerList() {
        try{
          let PassengerReq = []
          let reqList = [...this.updateCustomerInfoList];
          reqList.forEach(item => {
            let luggage = item.luggage;

            if(typeof item.luggage === "object") {
              const isEtc = luggage.indexOf(-1);
              if(isEtc > 0) {
                luggage[isEtc] = item.selectedLuggageInput;
              }
              luggage = item.luggage.join();
            }
            PassengerReq.push({
              passengerType : item.passengerType,
              luggage :luggage ,
              usages : item.usages === -1 ? item.selectedUseInput : item.usages,
              customerId : item.customerId
            })
          });

          const onCntSum = this.passengerDataList.reduce((acc, value) => (acc + value.onCnt), 0)
          const offCntSum = this.passengerDataList.reduce((acc, value) => (acc + value.offCnt), 0)

          if (this.passengerList.length !== onCntSum) {
            this.$store.commit('snackbar', {where: 'makeReqReservationData', msg: '탑승 인원의 합을 '+this.passengerList.length+' 명으로 변경해 주세요.'});
            return;
          } else if (this.passengerList.length !== offCntSum) {
            this.$store.commit('snackbar', {where: 'makeReqReservationData', msg: '하차 인원의 합을 '+this.passengerList.length+' 명으로 변경해 주세요.'});
            return;
          }

          const updatePassengerCntReq = this.passengerDataList.map(route => ({
            seq: route.seq,
            onCnt: route.onCnt,
            offCnt: route.offCnt
          }));

          const reqParam = {
            reservationId : this.reservationId,
            passengerDtos : PassengerReq,
            updatePassengerCntReq: updatePassengerCntReq
          }

          const res = await this.$api.updateReservationPassenger(reqParam);
          if(res.status === 200) {
            await this.reqReservation();
          }
          this.updateCustomerInfoList = [];
          this.updateCustomerDialog = false;
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'updateCustomerList'});
        }

      },
      async reqTinyUpdateReservation(reservations) {
        try {
          await this.$api.updateReservation(reservations);
          await this.reqReservation();

        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqTinyUpdateReservation'});
        }
      },
      async reqDeleteReservation(type) {
        try {
          const res = await this.$api.deleteReservation(this.reservationId);

          if (type && type === 'update') { // 예약 변경 일 경우 예약접수로 이동
            this.$router.push(`/reserve/rsv/${this.reservationId}`);
          } else // 예약 삭제 일 경우 예약 내역으로 이동
            this.$router.push('/reservation');
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqDeleteReservation'});
        }
      },
      onDeleteCustomer() {
        this.$store.commit('alert',
          {
            open: true, persistent: true, msg: "예약 취소를 하시겠습니까?",
            confirm: true, callBack: () => {
              this.reqDeleteReservation();
            }
          });
      },
      async onUpdateReservation() {
        const res = await this.$api.checkEnableReservation(this.reservationId);
        if (!res.data) {
          this.$store.commit('alert',
            {
              open: true, persistent: true, msg: "이용중 상태의 예약정보는 변경할 수 없습니다.",
              info: true
            });
            return;
        }

        this.$store.commit('alert',
          {
            open: true, persistent: true, msg: "예약을 변경하시겠습니까?\n변경을 진행하려면 확인버튼을 눌러주세요.",
            confirm: true, callBack: () => {
              this.$router.push(`/reserve/rsv/${this.reservationId}`);
            }
          });
      },
      async onUpdateReservationInfo() {
        const res = await this.$api.checkEnableReservation(this.reservationId);
        if (!res.data) {
          this.$store.commit('alert',
            {
              open: true, persistent: true, msg: "이용중 상태의 예약정보는 변경할 수 없습니다.",
              info: true
            });
          return;
        }

        this.updateResrvInfoDialog = true;
      },
      onChangeReservationState(state) {
        if (state === 'rs_cancel') {
          // 취소사유 다이얼로그
          this.cancelDialogOpen = true;

        } else if (state === 'rs_receipt') {
          this.$store.commit('alert',
            {
              open: true, persistent: true, msg: "배차 대기 상태로 변경하시겠습니까?",
              confirm: true, callBack: () => {

                const reqData = {
                  reservationId: this.reservationId,
                  configString: 'rs_receipt'
                };

                this.reqChangeReservationState(reqData);
              }
            });
        }
      },
      async reqChangeReservationState(data) {
        try {
          await this.$api.changeReservationState(data);
          
          this.reqReservation(); 
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqChangeReservationState'});
        }
      },
      onCanceledReservation(type) {
        // 1: 무단취소, 2: 정상취소
        const reqParam = {
          reservationId : this.reservationInfo[0].reservationId,
          isUserCancel : type === 2 ? false: true
        }
        this.reqAddCanceledReservation(reqParam);
        this.cancelDialogOpen = false;
      },
      async reqAddCanceledReservation(reqParam) {
        try {
          await this.$api.createCanceledReservation(reqParam);
          this.$router.push(`/canceledReservation/${reqParam.reservationId}`);
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqAddCanceledReservation'});
        }
      },
      async reqReservation() {
        try {
          const res = await this.$api.getReservationWithPassengers(this.reservationId);
          this.reservationInfo = res.data.reservationList;
          this.passengerList = res.data.passengerList;
          this.reservationWithPassenger = res.data;
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqReservation'});
        }
      },
      onUpdateReservationPassenger() {
        let bookerIndex = 0;

        //deep copy를 위해 사용
        let resList = JSON.parse(JSON.stringify(this.reservationWithPassenger.passengerList));
        for(let idx in resList) {
          const item = resList[idx];
          if(item.passengerType === 'BOOKER') {
            bookerIndex = idx;
          }
        }
        const booker = resList.splice(bookerIndex, 1)
        let newList = [...booker, ...resList ];
        let useList = this.$store.state.centerInfo.useList.split(',');
        let luggageList = this.$store.state.luggageList.map(item => item.value);
        for(let idx in newList) {

          const item = newList[idx];
          const selectedLuggage = item.luggage.split(',');
          item['name'] = item.customerName;
          item['mobileNo'] = item.customerNo;
          item['idx'] = idx;
          item['luggage'] = selectedLuggage
          item['type'] = item.passengerType;

          if (!useList.includes(item.usages)) {
            item['selectedUseInput'] = item.usages;
            item['usages'] = -1;
          }

          for (let idx in selectedLuggage) {
            let luggage = selectedLuggage[idx];
            if (!luggageList.includes(luggage)) {
              item['selectedLuggageInput'] = luggage;
              item['luggage'][idx] = -1
            }
          }

        }
        this.updateCustomerInfoList = newList;
        this.updateCustomerDialog = true;
      }
    }
  }
</script>
<style scoped>
  .waypoint {
    margin-top: 3px;
  }
</style>
